import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cardContainerMultiColumnStyles } from "@insite/content-library/Components/CardContainerMultiColumn";
import { actionsStyles } from "@insite/content-library/Widgets/ProductList/ProductListActions";
import { listStyles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

export interface ProductListColumnsStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
}
listStyles.wrapper = {
    css: css`
        margin-top: 0px;
        border-top: none;
    `,
};
cardContainerMultiColumnStyles.cardDivider = {
    css: css`
        padding: 0 10px;
        margin: 0 10px;
        height: 100%;
        width: 100%;
        overflow: auto;
        border-bottom: none;
        background: #fff;
        border-radius: 7px;
        // border: 1px solid rgb(239, 239, 239);
        // box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
        border: 1px solid rgb(204 204 204);
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
        div
            > div[class^="GridWrapper"]
            > div[class^="GridOffset"]
            > div[class^="GridItemStyle"]
            > a
            > span[class^="TypographyStyle"] {
            height: fit-content;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            height: auto;
                        `,
                        css`
                            height: auto;
                        `,

                        null,
                    ],
                    "max",
                )}
        }
    `,
};

actionsStyles.addToCartWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        margin-top: 10px;
        align-items: center;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-direction: column;
                        align-items: start;
                    `,
                    css`
                        flex-direction: column;
                        align-items: start;
                    `,

                    null,
                ],
                "max",
            )}
        div[class^="FormFieldStyle"] {
            display: flex;
            flex-direction: row;
            width: 50%;
            margin-bottom: 0px;
            min-width: 50%;
            margin-right: 0px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100%;
                            min-width: 100%;
                            margin-bottom: 10px;
                        `,
                        css`
                            width: 80%;
                            min-width: 80%;
                            margin-bottom: 10px;
                        `,

                        null,
                    ],
                    "max",
                )}
            label {
                min-height: 40px;
                display: flex;
                align-items: center;
                width: 30%;
                border-radius: 7px;
                justify-content: center;
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
                background: #ccc;
            }
            > div[class^="FormInputWrapper"] {
                margin-top: 0;
                width: 70%;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                width: 70%;
                            `,
                            css`
                                width: 50%;
                            `,

                            null,
                        ],
                        "max",
                    )}
                input {
                    border-radius: 0 7px 7px 0;
                    height: 40px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(
                            theme,
                            [
                                null,
                                null,
                                null,
                                css`
                                    height: 40px;
                                `,

                                null,
                            ],
                            "max",
                        )}

                    width: 75%;
                    background: #fff;
                }
            }
        }
        button[class^="ButtonWrapper"] {
            width: 50%;
            padding: 0 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            width: 100% !important;
                        `,
                        css`
                            width: 100% !important;
                        `,

                        null,
                    ],
                    "max",
                )}
        }
    `,
};
productGridCardStyles.wrapper = {
    css: css`
        padding: 10px;
        // background: #fff;
        // border-radius: 10px;
        // border: 1px solid rgb(239, 239, 239);
        // box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 5px 0px;
    `,
};
export const columnsStyles: ProductListColumnsStyles = {
    container: {
        gap: 0,
    },
    leftColumnGridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            > div[class^="Wrapper"] {
                border: 0px !important;
                box-shadow: none !important;
                background: none !important;
                padding: 10px;
                border-radius: 7px;
                margin-right: 20px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                margin-right: 0px;
                            `,
                        ],
                        "max",
                    )}
                > div[class^="sc"]:first-child {
                    border: none !important;
                    //background: #a81010;
                    border-radius: 0px;
                    justify-content: center;
                    display: flex;
                    align-items: start;
                    // border-bottom: 1px solid #a81010;
                    > h3 {
                        color: #a81010;
                        font-size: 20px;
                        font-weight: 600;
                        margin-bottom: 0;
                        display: none !important;
                    }
                }
                > div[class^="sc"] {
                    > h6 {
                        margin-top: 1rem;
                    }
                }
            }
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 9, 9, 9],
        css: css`
            //  padding-left: 15px;
        `,
    },
};

const styles = columnsStyles;

const ProductListColumns: FC<Props> = ({ id }) => {
    return (
        <GridContainer {...styles.container}>
            <GridItem {...styles.leftColumnGridItem}>
                <Zone contentId={id} zoneName="Content00" />
            </GridItem>
            <GridItem {...styles.rightColumnGridItem}>
                <Zone contentId={id} zoneName="Content01" />
            </GridItem>
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: ProductListColumns,
    definition: {
        group: "Product List",
        displayName: "Columns",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
